// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1E_4r","head":"Table_head__3iwrf","col":"Table_col__3rf86"};